import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { GenerateInvoice } from './actions/generate-invoice-action';
import { TransactionHelperActionDefault } from './actions/transaction-helper-action-default';
import { Action } from './actions/transaction-helper-action.interface';
import { UploadPaymentReceipts } from './actions/upload-payment-receipts';

@Injectable({
    providedIn: 'root'
})
export class TransactionHelperActionsRepository {
    private actions: Record<string, Action<any>>;

    public constructor(private router: Router) {
        this.actions = {
            generate_invoice: new GenerateInvoice(this.router),
            upload_payment_receipts: new UploadPaymentReceipts(this.router),
            default: new TransactionHelperActionDefault()
        };
    }

    public getAction(actionKey: string): Action<any> {
        return this.actions[actionKey] || this.actions['default'];
    }
}
